import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
      marginBottom: theme.spacing(12.5),
      background: COLORS.gray.gray90,
    },
    detailsBody: {
      background: COLORS.gray.gray80,
      padding: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    boxGroupTitle: {
      color: COLORS.gray.gray30,
      ...theme.typography.semiBold12,
    },
    groupContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      '& + &': {
        marginTop: theme.spacing(2),
      },
    },
  }),
  { name: 'BlogInsightsPanel' }
);
